import { getViewAndUpdatePaymentMethodsCTA } from "./shared";
export var ChangeDefaultPaymentMethodIA = function ChangeDefaultPaymentMethodIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return CHANGE_DEFAULT_PAYMENT_METHOD(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [CHANGE_DEFAULT_PAYMENT_METHOD_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewAndUpdatePaym;
        return (_getViewAndUpdatePaym = getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)) === null || _getViewAndUpdatePaym === void 0 ? void 0 : _getViewAndUpdatePaym.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewAndUpdatePaym2, _getViewAndUpdatePaym3;
        return (_getViewAndUpdatePaym2 = getViewAndUpdatePaymentMethodsCTA(context, strictLocalize)) === null || _getViewAndUpdatePaym2 === void 0 ? void 0 : (_getViewAndUpdatePaym3 = _getViewAndUpdatePaym2.getLink) === null || _getViewAndUpdatePaym3 === void 0 ? void 0 : _getViewAndUpdatePaym3.call(_getViewAndUpdatePaym2);
      }
    }
  };
};
var CHANGE_DEFAULT_PAYMENT_METHOD = function CHANGE_DEFAULT_PAYMENT_METHOD(strictLocalize) {
  return strictLocalize({
    id: "Qyd4db",
    defaultMessage: "Change default payment method"
  });
};
var CHANGE_DEFAULT_PAYMENT_METHOD_EXPLANATION = function CHANGE_DEFAULT_PAYMENT_METHOD_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "fENhjU",
    defaultMessage: "You can change the default payment method by clicking the button below. The payment method marked as default at the time your invoice comes due is the one that will be charged. If your default payment method fails, your alternate payment method on file may be charged."
  });
};